import 'react-app-polyfill/ie11';
import React from 'react';
import {render} from 'react-dom';
import './index.scss';
// import * as serviceWorker from './serviceWorker';
import Root from './components/Root';
import TagManager from 'react-gtm-module'

TagManager.initialize({gtmId: 'GTM-KZXCFSK', dataLayerName: 'dataLayer'})

render(
    <Root />,
    document.getElementById('root')
);

// serviceWorker.register();
